<template>
    <VJoyWrapper no-margin column-gap="3" wrap="nowrap">
        <VJoyWrapper v-if="reviewStats" no-margin column-gap="1" wrap="nowrap">
            <VJoyIcon name="star-fill" color="quaternary" size="xsmall" />
            <VJoyText preset="primary-250">{{ reviewStats.averageRating }}</VJoyText>
            <VJoyText preset="primary-200">({{ reviewStats.numberOfRatings }})</VJoyText>
        </VJoyWrapper>
        <VJoyWrapper v-if="numberOfRecos > 0" no-margin column-gap="1" wrap="nowrap">
            <VJoyIcon name="thumbup" color="neutral-50" size="xsmall" />
            <VJoyText preset="primary-250">{{ numberOfRecos }}</VJoyText>
        </VJoyWrapper>
    </VJoyWrapper>
</template>
<script setup lang="ts">
    import {VJoyIcon, VJoyText, VJoyWrapper} from '@maltjoy/core-vue';
    import type {SimilarProfileReviews} from '@api';

    defineProps<{
        reviewStats?: SimilarProfileReviews;
        numberOfRecos: number;
    }>();
</script>
